// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iiAlY08Ir_2i0CCPXh8A {
  overflow: hidden;
  max-width: 25rem;
}

.l0ePpOi9kSeSiBPs4QKo {
  display: flex;
}

.Rl0ZX8Uaf5Nhc5npfjiK {
  position: relative
}

.Rl0ZX8Uaf5Nhc5npfjiK img {
    height: 3.25rem;
    width: 4.375rem;
    object-fit: cover;
    border-radius: var(--panel-narrow-border-radius);
    margin-right: 2.5rem;
  }

.qHr2F90mMhiCiAvO8_5X {
  cursor: default;
  pointer-events: none;
}

@media only screen and
  (max-width: 639px) {
  .iiAlY08Ir_2i0CCPXh8A {
    overflow: hidden;
    max-width: 9.25rem;
  }
    .Rl0ZX8Uaf5Nhc5npfjiK img {
      margin-right: 0.5rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/EmblaSliderThumbs/EmblaSliderThumbs.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;AASF;;AAPE;IACE,eAAY;IACZ,eAAW;IACX,iBAAiB;IACjB,gDAAgD;IAChD,oBAAkB;EACpB;;AAGF;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EACE;IACE,gBAAgB;IAChB,kBAAgB;EAClB;IAGE;MACE,oBAAiB;IACnB;AAEJ","sourcesContent":[".emblaThumbnails {\n  overflow: hidden;\n  max-width: 400px;\n}\n\n.emblaThumbnailsContainer {\n  display: flex;\n}\n\n.emblaThumbnail {\n  position: relative;\n\n  & img {\n    height: 52px;\n    width: 70px;\n    object-fit: cover;\n    border-radius: var(--panel-narrow-border-radius);\n    margin-right: 40px;\n  }\n}\n\n.disabled {\n  cursor: default;\n  pointer-events: none;\n}\n\n@media (--mobile) {\n  .emblaThumbnails {\n    overflow: hidden;\n    max-width: 148px;\n  }\n\n  .emblaThumbnail {\n    & img {\n      margin-right: 8px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emblaThumbnails": `iiAlY08Ir_2i0CCPXh8A`,
	"emblaThumbnailsContainer": `l0ePpOi9kSeSiBPs4QKo`,
	"emblaThumbnail": `Rl0ZX8Uaf5Nhc5npfjiK`,
	"disabled": `qHr2F90mMhiCiAvO8_5X`
};
export default ___CSS_LOADER_EXPORT___;
